import { AbstractControl } from '@angular/forms';
import { ValidationResult } from './validation-result';

export class FullNameValidator {
  static validateName(control: AbstractControl): ValidationResult {
    const value = control.value;
    if (value && (value.toString().split(' ').length >= 2 && value.toString().split(' ')[1].trim() != '')) {
      if(value.toString().split(' ')[0].trim().length < 3){
        return { 'invalidName': true };
      }
      return null;
    } else if (value == null || value == undefined ) {
      return null;
    }
    return { 'invalidName': true };
  }
};